import type { RolMunicipal } from '@/api/modelos'

/**
 * Los roles del catalogo (`App\Soporte\Permisos`), con lo que hace cada
 * uno en una frase.
 *
 * El tipo sale del contrato, asi que un rol nuevo en la API rompe la
 * compilacion aqui hasta que alguien decida como se llama en pantalla, y uno
 * inventado no existe. Los roles son globales; lo que va por municipio es
 * QUIEN los tiene.
 */
export const ROLES: Record<RolMunicipal, string> = {
  administrador: 'Administrador',
  supervisor: 'Supervisor',
  gestor: 'Gestor',
  municipio: 'Municipio',
  administrador_municipal: 'Administrador municipal',
}

export const QUE_HACE: Record<RolMunicipal, string> = {
  administrador:
    'Todo, incluido dar de alta comunas y usuarios. Es NaturalPhone operando la plataforma.',
  supervisor: 'Dirige la operación: cartera, campañas, convenios y reportes. No aprueba textos.',
  gestor: 'Atiende contribuyentes: ve la cartera, registra gestiones y propone convenios.',
  municipio:
    'El municipio: aprueba plantillas, campañas y convenios, y edita el perfil de cobranza. No opera.',
  administrador_municipal:
    'Lo mismo que Municipio, y además crea campañas y administra las cuentas de su gente en esta comuna.',
}

export const ROLES_VALIDOS: readonly RolMunicipal[] = [
  'administrador',
  'supervisor',
  'gestor',
  'municipio',
  'administrador_municipal',
]

/**
 * Los roles que quien administra puede DAR. El de Administrador solo lo da la
 * plataforma (quien tiene municipios.administrar): la API lo rechaza igual,
 * pero ofrecerlo seria mostrar un boton que siempre falla.
 */
/**
 * Lo que puede dar quien no es la plataforma: Permisos::ROLES_QUE_DA_EL_MUNICIPIO.
 * Supervisor no: con una segunda cuenta suya redactaria y aprobaria la misma
 * plantilla. El servidor lo exige igual; esto solo evita ofrecer lo que falla.
 */
const ROLES_DEL_MUNICIPIO: readonly RolMunicipal[] = [
  'municipio',
  'administrador_municipal',
  'gestor',
]

export const rolesQuePuedeDar = (soyPlataforma: boolean): readonly RolMunicipal[] =>
  soyPlataforma ? ROLES_VALIDOS : ROLES_VALIDOS.filter((rol) => ROLES_DEL_MUNICIPIO.includes(rol))

/** Los roles que tienen usuarios.administrar: quien se baja a otro pierde esta pantalla. */
export const ADMINISTRAN_USUARIOS: readonly RolMunicipal[] = [
  'administrador',
  'administrador_municipal',
]

/** Lo que se ve en la columna de rol cuando la persona entra pero no tiene ninguno. */
export const SIN_ROL = 'Sin rol'
